(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["va-trust-badges"] && !Shopify.designMode) return;
  try {
    
(() => {
  const clips = new Map();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const inView = (node) => {
    const box = node.getBoundingClientRect();
    const visible = Math.min(box.bottom, window.innerHeight) - Math.max(box.top, 0);
    return box.height > 0 && visible >= Math.min(box.height, window.innerHeight) * .15;
  };
  const label = (clip) => {
    const paused = clip.video.paused;
    clip.control.setAttribute('aria-label', paused ? clip.control.dataset.playLabel : clip.control.dataset.pauseLabel);
    clip.control.querySelector('span').textContent = paused ? '▶' : 'Ⅱ';
  };
  const sync = (clip) => {
    const { video } = clip;
    video.muted = true;
    if (!clip.visible || clip.userPaused || document.hidden || (motion.matches && !clip.manualPlay)) {
      video.pause();
      label(clip);
      return;
    }
    if (!video.paused || clip.pending || video.error) return;
    clip.pending = true;
    const result = video.play();
    if (result && typeof result.then === 'function') {
      result.catch(() => { label(clip); }).finally(() => { clip.pending = false; });
    } else {
      clip.pending = false;
      label(clip);
    }
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    for (const entry of entries) {
      const clip = clips.get(entry.target);
      if (clip) { clip.visible = inView(entry.target); sync(clip); }
    }
  }, { threshold: [0, .15, .35, 1] }) : null;
  const init = () => {
    document.querySelectorAll('.va-coffee-native, .va-smart-native').forEach((node) => {
      if (clips.has(node)) return;
      const video = node.querySelector('video');
      const control = node.querySelector('.va-native-control');
      if (!video || !control) return;
      const clip = { video, control, visible: inView(node), userPaused: false, manualPlay: false, pending: false, dispose: [] };
      const on = (target, event, handler) => {
        target.addEventListener(event, handler);
        clip.dispose.push(() => target.removeEventListener(event, handler));
      };
      clips.set(node, clip);
      video.muted = true;
      video.defaultMuted = true;
      video.playsInline = true;
      video.loop = true;
      const clipStart = Number(video.dataset.clipStart || 0);
      const seekStart = () => { if (clipStart > 0 && video.readyState >= 1 && video.currentTime < clipStart) video.currentTime = clipStart; };
      on(video, 'loadedmetadata', seekStart);
      on(video, 'timeupdate', seekStart);
      on(video, 'seeking', seekStart);
      seekStart();
      if (motion.matches) video.removeAttribute('autoplay');
      on(video, 'play', () => { node.classList.remove('va-video-unavailable'); label(clip); });
      on(video, 'pause', () => label(clip));
      on(video, 'loadeddata', () => sync(clip));
      on(video, 'error', () => { node.classList.add('va-video-unavailable'); label(clip); });
      on(control, 'click', () => {
        clip.userPaused = !video.paused;
        clip.manualPlay = !clip.userPaused;
        clip.visible = inView(node);
        if (video.error) { node.classList.remove('va-video-unavailable'); video.load(); }
        sync(clip);
      });
      label(clip);
      if (observer) observer.observe(node);
      sync(clip);
    });
  };
  let frame = 0;
  const refresh = () => {
    if (frame) return;
    frame = window.requestAnimationFrame(() => {
      frame = 0;
      clips.forEach((clip, node) => { clip.visible = inView(node); sync(clip); });
    });
  };
  if (!observer) window.addEventListener('scroll', refresh, { passive: true });
  window.addEventListener('resize', refresh, { passive: true });
  window.addEventListener('pageshow', refresh);
  document.addEventListener('visibilitychange', refresh);
  const motionChanged = () => { clips.forEach((clip) => { clip.manualPlay = false; }); refresh(); };
  if (motion.addEventListener) motion.addEventListener('change', motionChanged);
  else if (motion.addListener) motion.addListener(motionChanged);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', () => {
    clips.forEach((clip, node) => {
      if (!node.isConnected) {
        clip.video.pause();
        clip.dispose.forEach((dispose) => dispose());
        if (observer) observer.unobserve(node);
        clips.delete(node);
      }
    });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

  } catch(e) { console.error(e); }
})();
})();
